import { useQuery } from '@tanstack/vue-query';
import { queries } from '~/keys';

export type BrandKitData = {
  displayName?: string | null;
  // Sales-offer wizard presentation settings (saved → later offers skip the personalise step).
  offerShowDeveloper?: boolean | null;
  offerSettingsSavedAt?: string | null;
  title?: string | null;
  companyName?: string | null;
  phone?: string | null;
  whatsapp?: string | null;
  email?: string | null;
  instagram?: string | null;
  website?: string | null;
  tagline?: string | null;
  brandColor?: string | null;
  secondaryColor?: string | null;
  accentColor?: string | null;
  profileImageUrl?: string | null;
  logoUrl?: string | null;
  font?: string | null;
  yearsExperience?: number | null;
  totalTransacted?: string | null;
  clientsServed?: string | null;
  avgDaysToOffer?: string | null;
  pctAskingAchieved?: string | null;
  testimonials?: { quote?: string; attribution?: string }[] | null;
} | null;

export const useBrandKitQuery = () => {
  const authStore = useAuthStore();

  return useQuery({
    ...queries.marketing.brandKit,
    queryFn: () =>
      $fetch<{ data: BrandKitData }>('/api/marketing/brand-kit', {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }).then((r) => r.data),
    retry: false,
  });
};

export const useMarketingHistoryQuery = () => {
  const authStore = useAuthStore();

  return useQuery({
    ...queries.marketing.history,
    queryFn: () =>
      $fetch<{ data: unknown[] }>('/api/marketing/history', {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }).then((r) => r.data),
    retry: false,
  });
};

export type MarketingUsage = {
  count: number;
  limit: number | null;
  remaining: number | null;
  unlimited: boolean;
};

export const useMarketingUsageQuery = () => {
  const authStore = useAuthStore();

  return useQuery({
    ...queries.marketing.usage,
    queryFn: () =>
      $fetch<{ data: MarketingUsage }>('/api/marketing/usage', {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }).then((r) => r.data),
    retry: false,
  });
};
